import { useEffect, useRef, useState } from "preact/hooks";
import PropTypes from "prop-types";
import YesNoInput from "@/components/input/yes-no.input.jsx";

export default function YesNoButtonInput({
  label,
  name,
  currentValue,
  onChange,
  hidden,
  mode = "toggle",
  disabled = false,
  className = "",
  buttonYesClass = "btn-neutral",
  buttonNoClass = "shadow-none light:bg-gray-100 dark:bg-gray-800 border-2 border-base-300",
  labelYesClass = "text-white",
  labelNoClass = "text-gray-500",
  children,
}) {
  const [value, setValue] = useState(currentValue);
  const inputRef = useRef(null);
  const handleOnChange = (e) => {
    onChange(e);
    setValue(e.target.value);
  };

  const handleOnClick = (e) => {
    e.preventDefault();
    setValue((value) => (value === "yes" ? "no" : "yes"));
    onChange({ target: { value: value === "yes" ? "no" : "yes", name } });
  };

  useEffect(() => {
    setValue(currentValue);
  }, [currentValue]);

  return (
    <div className={`${hidden ? `hidden ${className}` : className}`}>
      <button
        type="button"
        onClick={handleOnClick}
        className={`btn w-full h-[55px]!  ${value === "yes" ? buttonYesClass : buttonNoClass}`}
        disabled={disabled}
      >
        <div className="mt-0">
          <YesNoInput
            ref={inputRef}
            labelTextClassName={value === "yes" ? labelYesClass : labelNoClass}
            mode={mode}
            currentValue={value}
            onChange={handleOnChange}
            disabled={disabled}
            hidden={hidden}
            name={name}
            label={label}
          />
        </div>
      </button>
      {children}
    </div>
  );
}

YesNoButtonInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  currentValue: PropTypes.string,
  onChange: PropTypes.func,
  hidden: PropTypes.bool,
  mode: PropTypes.oneOf(["checkbox", "toggle"]),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  buttonYesClass: PropTypes.string,
  buttonNoClass: PropTypes.string,
  labelYesClass: PropTypes.string,
  labelNoClass: PropTypes.string,
  children: PropTypes.node,
};
